<template>
  <div>
    <mdb-form-inline class="active-cyan active-cyan-2">
      <mdb-btn color="indigo" @click="startFindingPhoneUserDataWithCode">{{
        $t("find_phone_user_data")
      }}</mdb-btn>
    </mdb-form-inline>
    <InputModal
      :modalShow="phoneSearchModal"
      :dataShow="dataLoadReady"
      :title="$t('find_user_phone_modal_title')"
      :description="$t('find_user_phone_modal_description')"
      :inputLabel="$t('find_user_phone_modal_inputlabel')"
      :buttontext="$t('find_user_phone_modal_button')"
      :dataModal="dataModal"
      v-on:modal-cancelled="phoneSearchCancelled"
      v-on:modal-ok="phoneSearch"
    />
  </div>
</template>

<script>
import { mdbBtn, mdbFormInline } from "mdbvue";
import InputModal from "./InputModal.vue";
export default {
  name: "FindPhoneUserDataWithCode",
  components: {
    mdbBtn,
    mdbFormInline,
    InputModal
  },
  data() {
    return {
      searchmode: true,
      phoneNumber: "",
      filterText: "",
      phoneSearchModal: false,
      dataLoadReady: false,
      dataModal: {
        columns: [
          {
            label: "Id",
            field: "id"
          },
          {
            label: "Tila",
            field: "invalidated"
          },
          {
            label: "Puhelinnumero",
            field: "tel"
          },
          {
            label: "Koodi",
            field: "password"
          },
          {
            label: "Käyttöönottoaika",
            field: "patchdate"
          },
          {
            label: "Voimassa saakka",
            field: "validto"
          }
        ],
        rows: null
      },
      retrievepath: "/1.0/password/retrievebytelorcode",
    };
  },
  methods: {
    phoneSearchCancelled() {
      this.phoneSearchModal = false;
    },
    phoneSearch(val, searchMode) {
      searchMode = true
      this.dataLoadReady = false;
      this.findPhoneUserDataWithCode(val, searchMode);
    },
    startFindingPhoneUserDataWithCode() {
      this.phoneSearchModal = true;
    },
    findPhoneUserDataWithCode(val) {
      this.$http
        .post(this.retrievepath, JSON.stringify({ sessionid: this.$store.getters.getToken, search: val }))
        .then(response => {
          if (response.status == 200) {
            this.dataModal.rows = [response.data];
            this.dataLoadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch(error => {
          return error;
        });
    }
  }
};
</script>

<style scoped>
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}
</style>
